<template>
  <div class="report" ref="reportView">
    <div class="reportBox">
      <el-row>
        <el-col :span="20">报表生成</el-col>
        <el-col :span="4">
          <!--          <el-button type="success" round icon="el-icon-check" size="small" @click="getData">确 认</el-button>-->
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearReport()">重 置</el-button>
        </el-col>
      </el-row>
      <div class="formBox">
        <el-form label-position="top" label-width="80px" :model="reportForm">
          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="日期">
                <el-date-picker
                  v-model="reportForm.date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                  :clearable="false"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="区域">
                <el-select
                  class="region"
                  v-model="reportForm.region"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="省份">
                <el-select
                  class="region"
                  v-model="reportForm.province"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="城市">
                <el-select
                  class="region"
                  v-model="reportForm.city"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="cluster Name">
                <el-select
                  class="region"
                  v-model="reportForm.clusterName"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in clusterList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="门店类型">
                <el-select
                  class="region"
                  v-model="reportForm.concept"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in conceptList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户">
                <el-select
                  class="region"
                  v-model="reportForm.reseller"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in customerList"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="City Tier">
                <el-select
                  class="region"
                  v-model="reportForm.cityTier"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in tierList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="TZ Group">
                <el-select
                  class="region"
                  v-model="reportForm.tzGroup"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in groupList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Format">
                <el-select
                  class="region"
                  v-model="reportForm.format"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                  @change="changeFilter"
                >
                  <el-option
                    v-for="item in formatList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="门店编号">
                <el-input
                  v-model="reportForm.posId"
                  placeholder="请输入门店编号"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="门店名">
                <span @click="onChooseDoor">
                  <el-input
                    readonly
                    v-model="reportForm.doorName"
                    placeholder="请输入门店名"
                    style="width: 100%"
                  ></el-input>
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="大项">
                <el-select
                  class="region"
                  v-model="reportForm.type"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                >
                  <el-option
                    v-for="item in bigList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">

            <el-col :span="8">
              <el-form-item label="检查项">
                <el-select
                  class="region"
                  v-model="reportForm.checkItem"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                >
                  <el-option
                    v-for="item in checkItemList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="问题">
                <el-select
                  class="region"
                  v-model="reportForm.question"
                  placeholder="请选择"
                  style="width: 100%"
                  multiple
                >
                  <el-option
                    v-for="item in questionList"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <footer>
        <el-button type="success" @click="save()">
          生成报表/导出为Excel
        </el-button>
<!--        <el-button type="success" @click="save()">
          导出为Excel
        </el-button>-->

        <el-button type="success" @click="exportImages()" v-if="progress === 1 || progress === 3">
          图片/视频下载
        </el-button>

        <el-button type="success" disabled v-if="progress === 2">
          正在处理
        </el-button>

        <el-button type="success" @click="openDownloadList">
          下载列表
        </el-button>
      </footer>
    </div>
    <pickDoor v-model="reportForm.posId" :filterForm="this.reportForm" ref='PickDoor'/>
    <el-dialog
      title="预约下载列表"
      :visible.sync="downloadDialog"
      width="60%"
      center>
      <div class="downloadList">
        <el-table :data="downloadList">
          <el-table-column property="name" label="预约人" width="130" ></el-table-column>
          <el-table-column property="exportTime" label="预约时间" width="170" ></el-table-column>
          <el-table-column property="condition" label="查询条件" ></el-table-column>
          <el-table-column property="status" label="状态" width="75" :show-overflow-tooltip="true" :formatter="statusFormatter">
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 'ok'"
                type="text"
                size="mini"
                @click="downloadData(scope.row.urls)"
              >下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <footer>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="downloadCurrentChange"
            :current-page="downloadTableConfig.current"
            :total="downloadTotal"
          ></el-pagination>
        </footer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadDialog = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
// 获取当月第一天
function getFirstDayOfMonth() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}-01`;
}

// 获取当月最后一天
function getLastDayOfMonth() {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const lastDay = new Date(year, month, 0).getDate();
  return `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
}

import md5 from "md5";
import _ from "lodash";
import tool from "../../utils/tool";
import PickDoor from "../../components/pickDoor";

export default {
  name: "Report",
  data() {
    return {
      id: this.$route.query.id || null,
      fullscreenLoading: false,
      reportForm: {},
      downloadUrl: "",  //下载地址
      initialReportForm: {
        province: [],
        date: [getFirstDayOfMonth(), getLastDayOfMonth()],
        region: [],
        city: [],
        clusterName: [],
        concept: [],
        cityTier: [],
        tzGroup: [],
        format: [],
        reseller: [],
        posId: '',
        door: [],
        type: [],
        checkItem: [],
        question: [],
      },
      questionList: [],
      areaList: [],
      provinceList: [],
      cityList: [],
      clusterList: [],
      conceptList: [],
      tierList: [],
      groupList: [],
      formatList: [],
      customerList: [],
      posidList: [],
      storeNameList: [],
      bigList: ['陈列', '运营', '培训'],
      downloadDialog: false,
      downloadList: [], //下载列表
      downloadTotal: 0, // 下载列表总数量
      downloadTableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      queryProcess: null, //轮询预约下载进度
      progress: 1, //1预约下载 2正在处理
    }
  },
  computed: {
    checkItemList: ({$store: {getters}}) => getters.checkItemList // 检查项
  },
  mounted() {
    this.reportForm = _.cloneDeep(this.initialReportForm);
    this.$store.dispatch("getStoreCheckItems"); // 检查项
    this.getQuestions();
    this.getOptions()
  },
  components: {
    pickDoor: PickDoor,
  },
  methods: {
    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    },
    async getQuestions() {  //获取题目列表
      let res = await axios.post(oprReqUrl+"question/search", {});
      res = res.data
      if (res.code === 200) {
        let questions = [];
        res.data.list.forEach(function (item) {
          let q = {key: item.id, label: item.name};
          questions.push(q)
        });
        this.questionList = questions;
      }
    },
    async getOptions() {
      let res = await axios.post(oprReqUrl+"door/linkage", _.omit(this.reportForm, ['date']));
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.areaList = dataList.region || [];
        this.cityList = dataList.city || [];
        this.conceptList = dataList.concept || [];
        this.customerList = dataList.reseller || [];
        this.provinceList = dataList.province || [];
        this.clusterList = dataList.clusterName || [];
        this.tierList = dataList.cityTier || [];
        this.groupList = dataList.tzGroup || [];
        this.formatList = dataList.format || [];
        this.posidList = dataList.posid || [];
        this.storeNameList = dataList.door || [];
      }
    },
    goBack() {
      this.$router.push({path: '/pages/report'});
    },
    async save() {
      if (!this.reportForm.date) {
        this.$message.warning("请选择日期")
        return
      }

      const loading = this.$loading({
        target: this.$refs.reportView,
        lock: true,
        text: '正在生成报表,请耐心等待...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const resultData = this.reportForm;
      resultData.name = resultData.door;
      resultData.start = tool.initTime(this.reportForm.date[0]);
      resultData.end = tool.initTime(this.reportForm.date[1]);
      console.log('this.reportForm.posId', this.reportForm.posId)
      resultData.posId = (this.reportForm.posId && this.reportForm.posId.length) ? this.reportForm.posId.split(',') : []
      let res = await axios.post(oprReqUrl+"survey/report", resultData);
      if (res.data.code === 200) {
        loading.close();
        // window.open(res.data.data)
        const el = document.createElement('a');
        el.style.display = 'none';
        el.setAttribute('target', '_blank');
        el.href = res.data.data;
        document.body.appendChild(el);
        el.click();
        document.body.removeChild(el);
      }
    },

    changeFilter() {
      this.getOptions();
    },
    clearReport() {
      this.reportForm = _.cloneDeep(this.initialReportForm);
      this.getOptions();
    },


    async openDownloadList() {
      this.downloadDialog = true
      let res = await axios.post(oprReqUrl+"/survey/exportlist", this.downloadTableConfig);
      if (res.data.code === 200) {
        console.log('res.data', res.data)
        this.downloadList = res.data.data.records
        this.downloadTotal = res.data.data.total
      }
    },

    downloadCurrentChange(index) {
      // 分页
      this.downloadTableConfig.current = index;
      this.openDownloadList()
    },

    // 下载具体的文件
    downloadData(urls) {
      _.each(urls, (file) => {
        window.open(file)
      })
    },

    // 预约下载
    async exportImages() {
      if (!this.reportForm.date) {
        this.$message.warning("请选择日期")
        return
      }
      this.$confirm("确认后开始打包，打包完成后请进入下载列表进行下载", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const params = this.getParams()
          let res = await axios.post(oprReqUrl+"/survey/exportImage", params);
          if (res.data.code === 200) {
            // 正在处理...
            this.$message.success('预约成功');
            // this.changeProgress()
          }
          else {
            console.log('预约下载失败')
            // this.$message.error(res.data.msg);
          }
        })
        .catch(_ => {
        })
    },

    // 切换状态
    changeProgress(){
      if (this.progress !== 3) {
        this.progress += 1
      } else {
        this.progress = 1
      }
      if (this.progress === 2) {
        this.openQuery()
      } else {
        this.closeQuery()
      }
    },

    // 开启轮询
    openQuery() {
      this.queryProcess = setInterval(async () => {
        const params = this.getParams()
        let res = await axios.post(oprReqUrl+"/survey/exportImage", params);
        if (res.data.code === 200) {
          this.changeProgress()
        }
        else if (res.data.code === 403) {
          // 进入下一次轮询
          // this.$message.error(res.data.msg);
        } else {
          // 出错了
          this.initProgress()
        }
      },3500)
    },

    // 结束轮询
    closeQuery() {
      clearInterval(this.queryProcess)
      this.queryProcess = null
    },

    // 初始化状态
    initProgress() {
      this.progress = 1
      this.closeQuery()
    },

    getParams() {
      const resultData = _.cloneDeep(this.reportForm)
      resultData.name = resultData.door;
      resultData.start = tool.initTime(this.reportForm.date[0]);
      resultData.end = tool.initTime(this.reportForm.date[1]);
      resultData.posId = (this.reportForm.posId && this.reportForm.posId.length) ? this.reportForm.posId.split(',') : []
      return resultData
    },

    statusFormatter(row){ //状态格式化
      switch (row.status) {
        case 'ok':
          return "完成"
          break;
        case 'progress':
          return "进行中"
          break;
        default:
          return "未知"
          break;
      }
    },
  }
};
</script>
<style lang="sass" scoped>
.report
  min-width: 1050px

  .reportBox
    padding: 20px

    .formBox
      width: 100%
      margin-top: 20px

  footer
    padding-top: 20px
    text-align: right

</style>



// WEBPACK FOOTER //
// src/opr/pages/views/report.vue